import { NgModule } from '@angular/core';
import { FrameComponent } from './frame.component';
import { CommonModule } from '@angular/common';
import { UIModule } from '../../ui/ui.module';

@NgModule({
  declarations: [
    FrameComponent,
  ],
  exports: [
    FrameComponent
  ],
    imports: [
        CommonModule,
        UIModule
    ],
})
export class FrameModule { }
